export default () => {
    'use strict';

    const toolboxIconsWrapper = document.getElementById('toolbox-icons-box');
    const sprite = document.getElementById('__svg__icons__dom__');
    const menuToggle = document.querySelector('.toolbox-menu-button');

    menuToggle?.addEventListener('click', () => {
        document.querySelector('body')?.classList.toggle('toolbox-menu-closed');
    });

    function renderIcons(container: HTMLElement, sprite: HTMLElement) {
        let html = '';
        const svgs = sprite?.children;
        for (let x = 0; x < svgs.length; x++) {
            const label = svgs[x].getAttribute('id');
            html += `
                <div class="col-4 col-md-2 mt-5 d-inline-flex flex-column align-items-center text-center">
                    <svg class="icon fs-5" aria-hidden="true">
                        <use href="#${label}" />
                    </svg>
                    <small class="mt-2">${label}</small>
                </div>    
            `;
        }
        container.innerHTML = html;
    }

    if (toolboxIconsWrapper && sprite) {
        renderIcons(toolboxIconsWrapper, sprite);
    }
}
